import script from "./StatusNotificationManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusNotificationManagement.vue?vue&type=script&setup=true&lang=js"

import "./StatusNotificationManagement.vue?vue&type=style&index=0&id=f7015704&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7015704"]])

export default __exports__